import usePostReportApi from '@/composables/postReport/postReportApi'
import useConfiguration from '@/composables/configuration/configuration'
import { computed, Ref, ref } from 'vue'
import { computeOffset } from '@/helper/pagination'
import { PostReport } from '@/model/data-object/PostReport'
import usePostFactory from '@/composables/post/postFactory'

const hasNext = ref(true)
const loading = ref(false)
const totalCount = ref(0)
const postReportList: Ref<Array<PostReport>> = ref([])
let page = 1

export default function usePostReportLoader() {
  const { getReportedPosts } = usePostReportApi()
  const { configuration } = useConfiguration()
  const loadedCount = computed(() => postReportList.value.length)

  const loadNext = async () => {
    const offset = computeOffset(page, configuration.profilePageSize)
    const { response, request, count } = getReportedPosts(offset)
    const { createFromObject } = usePostFactory()
    loading.value = true
    await request()
    loading.value = false

    totalCount.value = count.value
    if (response.value) {
      response.value.forEach(postReportRef => {
        const postReport = postReportRef as PostReport
        postReport.post = createFromObject(postReport.post)
        postReportList.value.push(postReport as PostReport)
      })

      if (response.value.length < configuration.profilePageSize) {
        hasNext.value = false
      }
    }

    page++
  }

  const clear = () => {
    page = 1
    totalCount.value = 0
    hasNext.value = true
    postReportList.value = []
  }

  return {
    hasNext,
    loading,
    totalCount,
    loadedCount,
    page,
    postReportList,
    loadNext,
    clear,
  }
}
